import Vue from "vue"
import Router from "vue-router"
import ls from 'store2'
import api from "@/api"
import { setUserInfo } from "@/util"
import LoginA from "./views/LoginA.vue"
import Login from "./views/Login.vue"
import Main from "./views/Main.vue"


Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


export const coustantRouter = [
    {
        path: "*",
        component: () => import('./views/404.vue')
    },
    {
        meta: {
            title: "美孚OCM油液监测-管理员登录"
        },
        path: "/",
        redirect: "/customer/login"
    },

    {
        meta: {
            title: "美孚OCM油液监测-管理员登录"
        },
        path: "/admin/login",
        name: "login",
        component: LoginA
    },
    {
        meta: {
            title: "美孚OCM油液监测-客户登录"
        },
        path: "/customer/login",
        name: "login",
        component: Login
    },
    {
        meta: {
            title: "美孚OCM油液监测-关于"
        },
        path: "/about",
        name: "about",
        component: () => import("./views/About.vue")
    },
    {
        meta: {
            title: "美孚OCM油液监测-工具"
        },
        path: "/tools",
        name: "tools",
        component: () => import("./views/Tools.vue")
    },
    {
        meta: {
            title: "美孚OCM油液监测-loading"
        },
        path: "/loading",
        name: "loading",
        component: () => import("./views/Loading.vue")
    },
    {
        meta: {
            title: "Azure-loading"
        },
        path: "/azure",
        name: "Azure",
        component: () => import("./views/Azure.vue")
    },
]

export const asnycRouter=[
    {
        meta: {
            title: "美孚OCM油液监测-首页"
        },
        path: "/",
        name: "index",
        redirect: {
            name: "home"
        },
        component: Main,
        children: [
            {
                meta: {
                    title: "润滑点监测",
                    role:[]
                },
                path: "/",
                redirect: "/index"
            },

            {
                meta: {
                    title: "润滑点监测"
                },
                path: "/index",
                name: "home",
                component: () => import("./views/Index.vue")
            },

            // ======= 运营大盘 =======
            {
                meta: {
                    title: "数据大盘"
                },
                path: "/operate/datas",
                name: "operateDatas",
                component: () => import("./views/operate/datas.vue")
            },
            {
                meta: {
                    title: "统计分析"
                },
                path: "/operate/analysis",
                name: "operateAnalysis",
                component: () => import("./views/operate/analysis.vue")
            },
            {
                meta: {
                    title: "数据导出"
                },
                path: "/operate/dataexprt",
                name: "operatedataExprt",
                component: () => import("./views/operate/dataexprt.vue")
            },

            // ======= 报警 =======
            {
                meta: {
                    title: "诊断报告"
                },
                path: "/warning/diagnostic",
                name: "diagnostic",
                component: () => import("./views/warning/diagnostic.vue")
            },
            {
                meta: {
                    title: "历史报警记录"
                },
                path: "/warning/recordlist",
                name: "warningList",
                component: () => import("./views/warning/recordlist.vue")
            },
            {
                meta: {
                    title: "历史报警详情"
                },
                path: "/warning/record/:id",
                name: "warningDetail",
                component: () => import("./views/warning/recorddetail.vue")
            },
            {
                meta: {
                    title: "润滑点台账"
                },
                path: "/warning/standingBooklist",
                name: "warningStandingBooklist",
                component: () => import("./views/warning/standingBooklist.vue")
            },

            // ======= 业务管理 =======
            {
                meta: {
                    title: "搜索"
                },
                path: "/search",
                name: "search",
                component: () => import("./views/business/SearchList.vue")
            },

            {
                meta: {
                    title: "客户列表"
                },
                path: "/business/customerlist",
                name: "businessCustomerlist",
                component: () => import("./views/business/customerlist.vue")
            },

            {
                meta: {
                    title: "经销商列表"
                },
                path: "/business/dealerlist",
                name: "businessDealerlist",
                component: () => import("./views/business/dealerlist.vue")
            },

            {
                meta: {
                    title: "设备列表"
                },
                path: "/business/equipmentlist",
                name: "businessEquipmentlist",
                component: () => import("./views/business/equipmentlist.vue")
            },

            {
                meta: {
                    title: "润滑点列表"
                },
                path: "/business/rhlist",
                name: "equipmentRhlist",
                component: () => import("./views/business/rhlist.vue")
            },
            {
                meta: {
                    title: "查看诊断报告"
                },
                path: "/business/lookdiaticreport",
                name: "equipmentlookdiaticreport",
                component: () => import("./views/business/lookdiaticreport.vue")
            },
            {
                meta: {
                    title: "编辑诊断报告"
                },
                path: "/business/diaticreport",
                name: "equipmentdiaticreport",
                component: () => import("./views/business/diaticreport.vue")
            },
            {
                meta: {
                    title: "润滑点详情"
                },
                path: "/business/rhlist/:id",
                name: "equipmentRhdetail",
                component: () => import("./views/business/rhdetail.vue")
            },

            {
                meta: {
                    title: "传感器列表"
                },
                path: "/business/sensorlist",
                name: "businessSensorlist",
                component: () => import("./views/business/sensorlist.vue")
            },

            // ======= 知识库配置 =======
            {
                meta: {
                    title: "编辑"
                },
                path: "/knowledge/faultediting",
                name: "knowledgefaultediting",
                component: () => import("./views/knowledge/faultediting.vue")
            },
            {
                meta: {
                    title: "故障管理"
                },
                path: "/knowledge/faultmanagement",
                name: "knowledgefaultediting",
                component: () => import("./views/knowledge/faultmanagement.vue")
            },
            {
                meta: {
                    title: "设备树"
                },
                path: "/knowledge/devicetree",
                name: "knowledgedevicetree",
                component: () => import("./views/knowledge/devicetree.vue")
            },
            {
                meta: {
                    title: "行业配置"
                },
                path: "/knowledge/industry",
                name: "knowledgeIndustry",
                component: () => import("./views/knowledge/industry.vue")
            },
            {
                meta: {
                    title: "油品配置"
                },
                path: "/knowledge/oil",
                name: "knowledgeOil",
                component: () => import("./views/knowledge/oil.vue")
            },
            {
                meta: {
                    title: "设备类型配置"
                },
                path: "/knowledge/equiptype",
                name: "knowledgeEquiptype",
                component: () => import("./views/knowledge/equiptype.vue")
            },
            {
                meta: {
                    title: "润滑点管理"
                },
                path: "/knowledge/lubtionment",
                name: "knowledgeRhtype",
                component: () => import("./views/knowledge/lubtionment.vue")
            },
            {
                meta: {
                    title: "润滑点装置管理"
                },
                path: "/knowledge/device",
                name: "device",
                component: () => import("./views/knowledge/device.vue")
            },
            {
                meta: {
                    title: "网关管理"
                },
                path: "/knowledge/gateway",
                name: "knowledgeRhtype",
                component: () => import("./views/knowledge/gateway.vue")
            },
            {
                meta: {
                    title: "产品表"
                },
                path: "/knowledge/productEdit",
                name: "productEdit",
                component: () => import("./views/knowledge/productEdit.vue")
            },
            {
                meta: {
                    title: "编辑润滑点类型指标"
                },
                path: "/knowledge/lubricatingtype/:id",
                name: "lubricatingtype",
                component: () => import("./views/knowledge/lubricatingtype.vue")
            },
            {
                meta: {
                    title: "润滑点类型配置"
                },
                path: "/knowledge/rhtype",
                name: "knowledgeRhtype",
                component: () => import("./views/knowledge/rhtype.vue")
            },
            {
                meta: {
                    title: "传感器类型配置"
                },
                path: "/knowledge/sensortype",
                name: "knowledgeSensortype",
                component: () => import("./views/knowledge/sensortype.vue")
            },
            {
                meta: {
                    title: "阈值配置"
                },
                path: "/knowledge/yuzhi",
                name: "knowledgeYuzhi",
                component: () => import("./views/knowledge/yuzhi.vue")
            },

            // ======= 租户管理 =======
            {
                meta: {
                    title: "租户管理"
                },
                path: "/hire/hiremanager",
                name: "hiremanager",
                component: () => import("./views/hire/hiremanager.vue")
            },

            // ======= 账号管理 =======
            {
                meta: {
                    title: "美孚账号管理"
                },
                path: "/account/meifu",
                name: "accountMeifu",
                component: () => import("./views/account/meifu.vue")
            },
            {
                meta: {
                    title: "经销商账号管理"
                },
                path: "/account/dealer",
                name: "accountDealer",
                component: () => import("./views/account/dealer.vue")
            },
            {
                meta: {
                    title: "客户账号管理"
                },
                path: "/account/customer",
                name: "accountCustomer",
                component: () => import("./views/account/customer.vue")
            },

            // ======= 系统 & 系统管理 =======
            {
                meta: {
                    title: "账号管理"
                },
                path: "/system/account",
                name: "systemAccount",
                component: () => import("./views/system/account.vue")
            },
            {
                meta: {
                    title: "注册审批"
                },
                path: "/system/register",
                name: "systemRegister",
                component: () => import("./views/system/register.vue")
            },
            {
                meta: {
                    title: "经销商授权管理"
                },
                path: "/system/auth",
                name: "systemAuth",
                component: () => import("./views/system/auth.vue")
            },
            {
                meta: {
                    title: "用户协议编辑"
                },
                path: "/system/useragreement",
                name: "systemUseragreement",
                component: () => import("./views/system/useragreement.vue")
            },
            {
                meta: {
                    title: "公告编辑"
                },
                path: "/system/notice",
                name: "systemNotice",
                component: () => import("./views/system/notice.vue")
            },
            {
                meta: {
                    title: "操作日志"
                },
                path: "/system/log",
                name: "systemLog",
                component: () => import("./views/system/log.vue")
            },
            {
                meta: {
                    title: "协议"
                },
                path: "/system/agreement",
                name: "agreement",
                component: () => import("./views/system/viewxie.vue")
            },
            {
                meta: {
                    title: "消息中心"
                },
                path: "/system/news",
                name: "systemNews",
                component: () => import("./views/system/news.vue")
            },
            {
                meta: {
                    title: "版本更新记录"
                },
                path: "/system/versionRecord",
                name: "versionRecord",
                component: () => import("./views/system/versionRecord.vue")
            },
            {
                meta: {
                    title: "权限组管理"
                },
                path: "/system/limitauth",
                name: "limitauth",
                component: () => import("./views/system/limitauth.vue")
            },
            {
                meta: {
                    title: "故障分析"
                },
                path: "/default/default-detail",
                name: "defaultDetail",
                component: () => import("./views/default/default-detail.vue")
            },
            {
                meta: {
                    title: ""
                },
                path: "/default/faultdetails",
                name: "faultdetails",
                component: () => import("./views/default/faultdetails.vue")
            },
            // 看板
            {
                meta: {
                    title: "设备监测"
                },
                path: "/bulletin/detection",
                name: "faultdetails",
                component: () => import("./views/bulletin/detection.vue")
            },
        ]
    }
]

const router = new Router({
    mode: "history", //hash
    routes: [
        {
            path: "*",
            component: () => import('./views/404.vue'),
            meta: {
                needAuth: false,
            },
        },
        {
            meta: {
                title: "美孚OCM油液监测-管理员登录",
                needAuth: false,
            },
            path: "/",
            redirect: "/customer/login",
        },

        {
            meta: {
                title: "美孚OCM油液监测-管理员登录",
                needAuth: false,
            },
            path: "/admin/login",
            name: "login",
            component: LoginA,
        },
        {
            meta: {
                title: "美孚OCM油液监测-客户登录",
                needAuth: false,
            },
            path: "/customer/login",
            name: "login",
            component: Login
        },
        {
            meta: {
                title: "美孚OCM油液监测-关于",
                needAuth: false,
            },
            path: "/about",
            name: "about",
            component: () => import("./views/About.vue")
        },
        {
            meta: {
                title: "美孚OCM油液监测-工具",
                needAuth: false,
            },
            path: "/tools",
            name: "tools",
            component: () => import("./views/Tools.vue")
        },
        {
            meta: {
                title: "美孚OCM油液监测-loading",
                needAuth: false,
            },
            path: "/loading",
            name: "loading",
            component: () => import("./views/Loading.vue")
        },
        {
            meta: {
                title: "Azure-loading",
                needAuth: false,
            },
            path: "/azure",
            name: "Azure",
            component: () => import("./views/Azure.vue")
        },
        {
            meta: {
                title: "美孚OCM油液监测-首页",
                needAuth: true,
            },
            path: "/",
            name: "index",
            redirect: {
                name: "home"
            },
            component: Main,
            beforeEach: () => {},
            children: [
                {
                    meta: {
                        title: "润滑点监测",
                        needAuth: true,
                    },
                    path: "/",
                    redirect: "/index"
                },

                {
                    meta: {
                        title: "润滑点监测",
                        needAuth: true,
                    },
                    path: "/index",
                    name: "home",
                    component: () => import("./views/Index.vue")
                },

                // ======= 运营大盘 =======
                {
                    meta: {
                        title: "数据大盘",
                        needAuth: true,
                    },
                    path: "/operate/datas",
                    name: "operateDatas",
                    component: () => import("./views/operate/datas.vue")
                },
                {
                    meta: {
                        title: "统计分析",
                        needAuth: true,
                    },
                    path: "/operate/analysis",
                    name: "operateAnalysis",
                    component: () => import("./views/operate/analysis.vue")
                },
                {
                    meta: {
                        title: "数据导出",
                        needAuth: true,
                    },
                    path: "/operate/dataexprt",
                    name: "operatedataExprt",
                    component: () => import("./views/operate/dataexprt.vue")
                },

                // ======= 报警 =======
                {
                    meta: {
                        title: "诊断报告",
                        needAuth: true,
                    },
                    path: "/warning/diagnostic",
                    name: "diagnostic",
                    component: () => import("./views/warning/diagnostic.vue")
                },
                {
                    meta: {
                        title: "历史报警记录",
                        needAuth: true,
                    },
                    path: "/warning/recordlist",
                    name: "warningList",
                    component: () => import("./views/warning/recordlist.vue")
                },
                {
                    meta: {
                        title: "历史报警详情",
                        needAuth: true,
                    },
                    path: "/warning/record/:id",
                    name: "warningDetail",
                    component: () => import("./views/warning/recorddetail.vue")
                },
                {
                    meta: {
                        title: "润滑点台账",
                        needAuth: true,
                    },
                    path: "/warning/standingBooklist",
                    name: "warningStandingBooklist",
                    component: () => import("./views/warning/standingBooklist.vue")
                },

                // ======= 业务管理 =======
                {
                    meta: {
                        title: "设备点表",
                        needAuth: true,
                    },
                    path: "/business/poinrlist",
                    name: "poinrlist",
                    component: () => import("./views/business/poinrlist.vue")
                },
                {
                    meta: {
                        title: "搜索",
                        needAuth: true,
                    },
                    path: "/search",
                    name: "search",
                    component: () => import("./views/business/SearchList.vue")
                },

                {
                    meta: {
                        title: "客户列表",
                        needAuth: true,
                    },
                    path: "/business/customerlist",
                    name: "businessCustomerlist",
                    component: () => import("./views/business/customerlist.vue")
                },

                {
                    meta: {
                        title: "经销商列表",
                        needAuth: true,
                    },
                    path: "/business/dealerlist",
                    name: "businessDealerlist",
                    component: () => import("./views/business/dealerlist.vue")
                },

                {
                    meta: {
                        title: "设备列表",
                        needAuth: true,
                    },
                    path: "/business/equipmentlist",
                    name: "businessEquipmentlist",
                    component: () => import("./views/business/equipmentlist.vue")
                },

                {
                    meta: {
                        title: "润滑点列表",
                        needAuth: true,
                    },
                    path: "/business/rhlist",
                    name: "equipmentRhlist",
                    component: () => import("./views/business/rhlist.vue")
                },
                {
                    meta: {
                        title: "查看诊断报告",
                        needAuth: true,
                    },
                    path: "/business/lookdiaticreport",
                    name: "equipmentlookdiaticreport",
                    component: () => import("./views/business/lookdiaticreport.vue")
                },
                {
                    meta: {
                        title: "编辑诊断报告",
                        needAuth: true,
                    },
                    path: "/business/diaticreport",
                    name: "equipmentdiaticreport",
                    component: () => import("./views/business/diaticreport.vue")
                },
                {
                    meta: {
                        title: "润滑点详情",
                        needAuth: true,
                    },
                    path: "/business/rhlist/:id",
                    name: "equipmentRhdetail",
                    component: () => import("./views/business/rhdetail.vue")
                },

                {
                    meta: {
                        title: "传感器列表",
                        needAuth: true,
                    },
                    path: "/business/sensorlist",
                    name: "businessSensorlist",
                    component: () => import("./views/business/sensorlist.vue")
                },

                // ======= 知识库配置 =======
                {
                    meta: {
                        title: "编辑",
                        needAuth: true,
                    },
                    path: "/knowledge/faultediting",
                    name: "knowledgefaultediting",
                    component: () => import("./views/knowledge/faultediting.vue")
                },
                {
                    meta: {
                        title: "故障管理",
                        needAuth: true,
                    },
                    path: "/knowledge/faultmanagement",
                    name: "knowledgefaultediting",
                    component: () => import("./views/knowledge/faultmanagement.vue")
                },
                {
                    meta: {
                        title: "设备树",
                        needAuth: true,
                    },
                    path: "/knowledge/devicetree",
                    name: "knowledgedevicetree",
                    component: () => import("./views/knowledge/devicetree.vue")
                },
                {
                    meta: {
                        title: "行业配置",
                        needAuth: true,
                    },
                    path: "/knowledge/industry",
                    name: "knowledgeIndustry",
                    component: () => import("./views/knowledge/industry.vue")
                },
                {
                    meta: {
                        title: "油品配置",
                        needAuth: true,
                    },
                    path: "/knowledge/oil",
                    name: "knowledgeOil",
                    component: () => import("./views/knowledge/oil.vue")
                },
                {
                    meta: {
                        title: "设备类型配置",
                        needAuth: true,
                    },
                    path: "/knowledge/equiptype",
                    name: "knowledgeEquiptype",
                    component: () => import("./views/knowledge/equiptype.vue")
                },
                {
                    meta: {
                        title: "润滑点管理",
                        needAuth: true,
                    },
                    path: "/knowledge/lubtionment",
                    name: "knowledgeRhtype",
                    component: () => import("./views/knowledge/lubtionment.vue")
                },
                {
                    meta: {
                        title: "润滑点装置管理",
                        needAuth: true,
                    },
                    path: "/knowledge/device",
                    name: "device",
                    component: () => import("./views/knowledge/device.vue")
                },
                {
                    meta: {
                        title: "网关管理",
                        needAuth: true,
                    },
                    path: "/knowledge/gateway",
                    name: "knowledgeRhtype",
                    component: () => import("./views/knowledge/gateway.vue")
                },
                {
                    meta: {
                        title: "产品表",
                        needAuth: true,
                    },
                    path: "/knowledge/productEdit",
                    name: "productEdit",
                    component: () => import("./views/knowledge/productEdit.vue")
                },
                {
                    meta: {
                        title: "编辑润滑点类型指标",
                        needAuth: true,
                    },
                    path: "/knowledge/lubricatingtype/:id",
                    name: "lubricatingtype",
                    component: () => import("./views/knowledge/lubricatingtype.vue")
                },
                {
                    meta: {
                        title: "润滑点类型配置",
                        needAuth: true,
                    },
                    path: "/knowledge/rhtype",
                    name: "knowledgeRhtype",
                    component: () => import("./views/knowledge/rhtype.vue")
                },
                {
                    meta: {
                        title: "传感器类型配置",
                        needAuth: true,
                    },
                    path: "/knowledge/sensortype",
                    name: "knowledgeSensortype",
                    component: () => import("./views/knowledge/sensortype.vue")
                },
                {
                    meta: {
                        title: "阈值配置",
                        needAuth: true,
                    },
                    path: "/knowledge/yuzhi",
                    name: "knowledgeYuzhi",
                    component: () => import("./views/knowledge/yuzhi.vue")
                },

                // ======= 租户管理 =======
                {
                    meta: {
                        title: "租户管理",
                        needAuth: true,
                    },
                    path: "/hire/hiremanager",
                    name: "hiremanager",
                    component: () => import("./views/hire/hiremanager.vue")
                },

                // ======= 账号管理 =======
                {
                    meta: {
                        title: "美孚账号管理",
                        needAuth: true,
                    },
                    path: "/account/meifu",
                    name: "accountMeifu",
                    component: () => import("./views/account/meifu.vue")
                },
                {
                    meta: {
                        title: "经销商账号管理",
                        needAuth: true,
                    },
                    path: "/account/dealer",
                    name: "accountDealer",
                    component: () => import("./views/account/dealer.vue")
                },
                {
                    meta: {
                        title: "客户账号管理",
                        needAuth: true,
                    },
                    path: "/account/customer",
                    name: "accountCustomer",
                    component: () => import("./views/account/customer.vue")
                },

                // ======= 系统 & 系统管理 =======
                {
                    meta: {
                        title: "账号管理",
                        needAuth: true,
                    },
                    path: "/system/account",
                    name: "systemAccount",
                    component: () => import("./views/system/account.vue")
                },
                {
                    meta: {
                        title: "注册审批",
                        needAuth: true,
                    },
                    path: "/system/register",
                    name: "systemRegister",
                    component: () => import("./views/system/register.vue")
                },
                {
                    meta: {
                        title: "经销商授权管理",
                        needAuth: true,
                    },
                    path: "/system/auth",
                    name: "systemAuth",
                    component: () => import("./views/system/auth.vue")
                },
                {
                    meta: {
                        title: "用户协议编辑",
                        needAuth: true,
                    },
                    path: "/system/useragreement",
                    name: "systemUseragreement",
                    component: () => import("./views/system/useragreement.vue")
                },
                {
                    meta: {
                        title: "公告编辑",
                        needAuth: true,
                    },
                    path: "/system/notice",
                    name: "systemNotice",
                    component: () => import("./views/system/notice.vue")
                },
                {
                    meta: {
                        title: "操作日志",
                        needAuth: true,
                    },
                    path: "/system/log",
                    name: "systemLog",
                    component: () => import("./views/system/log.vue")
                },
                {
                    meta: {
                        title: "协议",
                        needAuth: true,
                    },
                    path: "/system/agreement",
                    name: "agreement",
                    component: () => import("./views/system/viewxie.vue")
                },
                {
                    meta: {
                        title: "消息中心",
                        needAuth: true,
                    },
                    path: "/system/news",
                    name: "systemNews",
                    component: () => import("./views/system/news.vue")
                },
                {
                    meta: {
                        title: "版本更新记录",
                        needAuth: true,
                    },
                    path: "/system/versionRecord",
                    name: "versionRecord",
                    component: () => import("./views/system/versionRecord.vue")
                },
                {
                    meta: {
                        title: "权限组管理",
                        needAuth: true,
                    },
                    path: "/system/limitauth",
                    name: "limitauth",
                    component: () => import("./views/system/limitauth.vue")
                },
                {
                    meta: {
                        title: "故障分析",
                        needAuth: true,
                    },
                    path: "/default/default-detail",
                    name: "defaultDetail",
                    component: () => import("./views/default/default-detail.vue")
                },
                {
                    meta: {
                        title: "",
                        needAuth: true,
                    },
                    path: "/default/faultdetails",
                    name: "faultdetails",
                    component: () => import("./views/default/faultdetails.vue")
                },
                // 看板
                {
                    meta: {
                        title: "设备监测",
                        needAuth: true,
                    },
                    path: "/bulletin/detection",
                    name: "faultdetails",
                    component: () => import("./views/bulletin/detection.vue")
                },
                // {
                //     path:"*",
                //     component:()=>import('./views/404.vue')
                // },
            ]
        }
    ]
});

router.beforeEach(async (to, from, next) => {
    if (to.meta.needAuth) {
        // 需要验证
        const resultData = await api.axsUserInfo("get", "/ocm-admin/user/me");
        if (resultData.code === "00000") {
            setUserInfo({
                ...resultData.data,
            });

            next();
        } else {
            const userRole = ls.get('userRole') || "";
            let loginPath = '/customer/login';
            if (userRole.indexOf('m') > -1) {
                loginPath = '/admin/login';
            }
            setTimeout(() => {
                window.location.reload();
            }, 500);
            next(loginPath);
        }
    } else {
        next();
    }
});

export default router;
